import omitBy from 'lodash/omitBy';
import isEmpty from 'lodash/isEmpty';

function join(arr /*, separator */) {
    const separator = arguments.length > 1 ? arguments[1] : ", ";
    return arr.filter(function(n){return n}).join(separator);
}

function formatCity(suggestion) {
    const address = suggestion.data;
    if (address.city_with_type === address.region_with_type) {
        return address.settlement_with_type || "";
    } else {
        return join([
            address.city_with_type,
            address.settlement_with_type]);
    }
}

function select(suggestion) {
  $.each(suggestion, function(index, value) {
    const el = $('#search-advanced input[name='+index+'][type=hidden]');
    //el.css({display: isEmpty(value) ? 'none' : null});
    el.val(value);
  });
  return true;
}

const
    token = "0094b8fbe5f591290aaefb7d4790c47ae15ba1bd",
    onSelect = suggestion => select(suggestion.data),
    type  = "ADDRESS",
    $region = $("#region_field"),
    $city   = $("#city_field"),
    $street = $("#street_field"),
    $house  = $("#house_field");

// регион и район
$region.suggestions({
    token: token,
    type: type,
    hint: false,
    deferRequestBy: 400,
    minChars: 2,
    onSelect,
    bounds: "region-area"
});

// город и населенный пункт
$city.suggestions({
    token: token,
    type: type,
    hint: false,
    deferRequestBy: 400,
    minChars: 2,
    bounds: "city-settlement",
    constraints: $region,
    onSelect,
    formatSelected: formatCity
});

// улица
$street.suggestions({
    token: token,
    type: type,
    hint: false,
    deferRequestBy: 400,
    minChars: 2,
    bounds: "street",
    onSelect,
    constraints: $city
});

// дом
$house.suggestions({
    token: token,
    type: type,
    hint: false,
    triggerSelectOnBlur: true,
    noSuggestionsHint: false,
    bounds: "house",
    onSelect,
    deferRequestBy: 400,
    constraints: $street
});


// WEBPACK FOOTER //
// ./src/view/cadastral/search-advanced/index.js